module.exports = __webpack_public_path__ + "img/Group 127@2x.9102f379.png";